/**
 * RESPONSIBILITY: draw a band that is one picture.
 */
import { Picture } from '../Picture';
import { BandFrame } from './BandFrame';
import type { BandDef, BandProps } from './kind';

function Draw({ b, tinted }: BandProps) {
  return (
    <BandFrame tinted={tinted} heading={b.heading}>
      <div className="ministry-pic-container">
        <Picture value={b.image} alt={b.image?.alt} className="block-pic ministry-section-pic" />
      </div>
    </BandFrame>
  );
}

// A picture band with no picture would draw the grey placeholder at visitors.
export const image: BandDef = { has: (b) => !!b.image?.path, Draw };
